<div *ngIf="termsAccepted">
    <div class="alert alert-info alert-black" *ngIf="versionLiveNotification">
        <div class="float-left">
            <em class="iconFntPos"><span class="se-icon-information_stroke"></span></em> {{versionLiveData}}
        </div>
        <div class="float-right">
            <button class="se-button" (click)="closeVersionLiveNotification()">{{labels.ok}}</button>
        </div>
        <div class="clearfix"></div>
    </div>

    <div *ngIf="loading else loaded">
         <div class="se-loader mrgAuto10"></div>
    </div>
    <span *ngIf="uploading" class="winmsg">{{labels.uploadMsg}}</span>
    <span *ngIf="downloading" class="winmsg">{{labels.downloadMsg}}</span>
    <ng-template #loaded>
        <div class="intro-text" *ngIf="!appId">
            <p>Schneider Electric provides services to assist customers in the life cycle management of their industrial facilities.
            </p>
            <p class="mb-0">The objective of these services is to:
            </p>
            <ul class="mb-0">
                <li>Reduce the cost of operation and the risk / cost of renewal
                </li>
                <li>Extend the life of automation assets
                </li>
                <li>Retain the intellectual property of historical engineering investment
                </li>
            </ul>
        </div>
        
        <div class="container-fluid" *ngIf="!appId">
            <div>
                <h4 class="clearfix">
                    <strong>Discover our Offers :</strong>
                    <img height="20" width="20" *ngIf="!editable && isAdmin==='true'" (click)="editMode(true)" class="float-right float-icons" title="Edit Offers" src="assets/image/icons/edit.svg" alt="edit icon">
                    <img height="20" width="20" *ngIf="editable && isAdmin==='true'" (click)="revertChanges()" class="float-right float-icons" title="Cancel" src="assets/image/icons/close.svg" alt="close icon">
                    <img height="20" width="20" *ngIf="editable && isAdmin==='true'" [ngClass]="{'disabled': formInvalid}" (click)="saveDataPopup = true;" class="float-right float-icons mr-1" title="Save" src="assets/image/icons/save.svg" alt="edit icon">
                </h4>
            </div>
            <div class="row m-0 mt-3 justify-content-md-center child1" *ngIf="appLen > 0">
                <div class="col-md-12 col-lg-4 col-sm-4 p-0 mb-4" *ngFor="let item of categoriesArray">
                    <div class="mr-2 border">
                        <div class="widget-holder">
                            <div class="widget-title">
                                <h4 class="float-left font-weight-bold">{{item.category}}</h4>
                                <div class="clearfix"></div>
                            </div>
                            <div class="col-sm-12 border-bottom pt-3 pb-2 padLftRht" *ngFor="let itemApp of item.applicationList | filter : searchText; let i = index;">
                                <div *ngIf="!editable" class="float-left text-life-green fntBold" [innerHTML]="itemApp.applicationName | bold"></div>
                                <div *ngIf="editable" class="float-left text-life-green fntBold">
                                    <input class="se-form-control editFormControl" (keyup)="validateData()" [(ngModel)]="itemApp.applicationName">
                                </div>
                                <div class="float-right" *ngIf="itemApp.isWebApp && itemApp.requestAccessURL !== null">
                                    <button class="se-button button-primary" *ngIf="itemApp.statusText === 'APPROVED'" (click)="viewTool(itemApp)">{{labels.viewTool}}</button>
                                    <button class="se-button button-primary" *ngIf="itemApp.statusText === 'DENIED' || itemApp.statusText === ''" (click)="openDialog(itemApp, '')">{{labels.requestAccess}}</button>
                                    <button class="se-button button-primary opacityDisabled" *ngIf="itemApp.statusText === 'PENDING'" disabled="disabled">{{labels.requestInitiated}}</button>
                                    <button class="se-button button-primary" *ngIf="itemApp.statusText === 'BLOCKED'" (click)="openDialog(itemApp, 'blockedBtn')">{{labels.unblock}}</button>
                                </div>
                                <div class="float-right" *ngIf="!itemApp.isWebApp">
                                    <button class="se-button button-primary" (click)="redirectTo(itemApp)">{{labels.knowMore}}</button>
                                </div>
                                <div class="float-right" *ngIf="itemApp.isWebApp && itemApp.requestAccessURL === null">
                                    <button class="se-button button-primary" (click)="viewTool(itemApp)">
                                        {{labels.viewTool}}
                                    </button>
                                </div>
                                <div class="clearfix"></div>
                                <div class="mt-2">
                                    <div *ngIf="itemApp.statusText === 'BLOCKED'" class="font-weight-bold clrRed">
                                        {{labels.unblockText}}
                                    </div>

                                    <ng-container>
                                        <div *ngIf="!editable">
                                            <p class="desc" [hidden]="hideme[itemApp.applicationId]">{{itemApp.description}}</p>
                                        </div>
                                        <div *ngIf="editable">
                                            <textarea class="se-form-control" rows="3" [(ngModel)]="itemApp.description">
                                            </textarea>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <p *ngIf="!appLen > 0" class="alert alert-success m-3">{{labels.noApplicationData}}</p>
        </div>
             
        <!-- Migration Expert Tool know more -->

    </ng-template>
</div>

<div class="se-dialog" *ngIf="termsAccepted === false">
    <form name="form" #f="ngForm">
        <div class="se-dialog-holder">
            <div class="se-complex-header">
                <h3 class="se-dialiog-title">{{labels.termsTitle}}</h3>
            </div>
            <div class="se-dialog-body">
                <p>{{labels.readText}}<br>{{labels.checkBelow}} :-</p>
                <p><a href="/terms" target="_blank" rel="noopener noreferrer">{{labels.termsCondition}}</a></p>
                <p><a href="/terms" target="_blank" rel="noopener noreferrer">{{labels.privacyPolicy}}</a></p>
                <p>
                    <label class="checkbox-holder">
                    <span>{{labels.agreeTerms}}</span>
                    <input class="check" type="checkbox" name="terms" [(ngModel)]="terms" required>
                    <span class="checkmark" data-color="primary"></span>
                </label>
                </p>
                <p>
                    <label class="checkbox-holder">
                    <span>{{labels.agreePolicy}}</span>
                    <input class="check" type="checkbox" required name="policy" [(ngModel)]="policy">
                    <span class="checkmark" data-color="primary"></span>
                </label>
                </p>
            </div>
            <div class="se-dialog-footer">
                <button class="se-button disabledCls" (click)="acceptTerms()" [disabled]="!f.form.valid" tabindex="-1">{{labels.accept}}</button>
                <button class="se-button" (click)="logout()" tabindex="-1">{{labels.decline}}</button>
            </div>
        </div>
    </form>
</div>

<!-- Loader -->

<!-- Confirmation popup -->
<div class="se-dialog" *ngIf="saveDataPopup">
    <div class="se-dialog-holder">
        <div class="se-complex-header">
            <h3 class="se-dialiog-title">{{labels.updateOffer}}</h3>
        </div>
        <div class="se-dialog-body">
            <p>{{labels.confirmMessage}}</p>
        </div>
        <div class="se-dialog-footer">
            <button class="se-button" (click)="revertChanges()">{{labels.no}}</button>
            <button class="se-button" (click)="saveData()">{{labels.yes}}</button>
        </div>
    </div>
</div>
<!-- Confirmation popup -->

